// F134 (founder ruling 11 Oct 2026): EVERY console date is CENTRAL time. Publish C moved every
// console date forward a day because the surfaces rendered UTC (or whatever the viewer's machine was
// set to), so an invitation issued in the Houston evening read as the next day.
//
// ONE date and ONE month format everywhere, built from a fixed month table rather than
// toLocaleDateString, because an ICU locale renders September as "Sept" — which is how one surface
// said "28 SEPT" and another "28 SEP". Only the ZONE comes from Intl.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const CENTRAL = "America/Chicago";

function parts(iso) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const f = new Intl.DateTimeFormat("en-US", {
    timeZone: CENTRAL, year: "numeric", month: "numeric", day: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false,
  });
  const out = {};
  f.formatToParts(d).forEach((p) => { if (p.type !== "literal") out[p.type] = p.value; });
  return { y: Number(out.year), m: Number(out.month), d: Number(out.day),
           hh: out.hour === "24" ? "00" : out.hour, mm: out.minute };
}

/** "28 Sep", in Central time. */
export function dateShort(iso) {
  if (!iso) return "—";
  const p = parts(iso);
  return p ? `${p.d} ${MONTHS[p.m - 1]}` : "—";
}

/** "28 Sep 2026", in Central time. */
export function dateLong(iso) {
  if (!iso) return "—";
  const p = parts(iso);
  return p ? `${p.d} ${MONTHS[p.m - 1]} ${p.y}` : "—";
}

/** "28 Sep 2026 · 19:40 CT" — a date AND a time always names the zone, so nobody has to guess. */
export function dateTime(iso) {
  if (!iso) return "—";
  const p = parts(iso);
  return p ? `${p.d} ${MONTHS[p.m - 1]} ${p.y} · ${p.hh}:${p.mm} CT` : "—";
}
